import { render, staticRenderFns } from "./conferencebillingsecretariart.vue?vue&type=template&id=4efca4d8"
import script from "./conferencebillingsecretariart.vue?vue&type=script&lang=js"
export * from "./conferencebillingsecretariart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports